import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Card, CardHeader, CardBody, CardFooter, Collapse, Tooltip } from 'reactstrap';
import { ConnectedUserContext } from '../connectedUser-context';
import { withRouter } from "../withRouter"; 	// HOC pour React Router v6

class TeamRosters extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			season: {name: ''},
			teams: [],
			homeSites: [],
			groupByHomeSite: false,
			loading: false
		};
	
		this.dispTeam = this.dispTeam.bind(this);
		this.dispTeams = this.dispTeams.bind(this);
		this.dispPlayers = this.dispPlayers.bind(this);
		this.dispHomeSiteSection = this.dispHomeSiteSection.bind(this);
		this.groupByHomeSiteSwitchChange = this.groupByHomeSiteSwitchChange.bind(this);
}

	componentDidMount() {
		this.loadSeasonFromApi();
	}

	loadSeasonFromApi() {
    var _this = this;
    var seasonTag = this.props.params.seasonTag;		// withRouter

    Axios.get('/api/seasons/tag/' + seasonTag).then(responseSeason => {
    	var season = responseSeason.data.season;

	    Axios.get('/api/teams/withPlayersBySeasonWithRatings/' + season._id).then(responseTeams => {
				if (Object.keys(responseSeason.data).length !== 0) {

		    	var teams = responseTeams.data;
					teams = teams.sort((a, b) => (a.name.localeCompare(b.name)));

					var homeSites = [];

		    	// get total TRS
		    	teams.forEach((team, teamIdx, teams) => {

		    		// Ratings
		    		var teamRating = 0;
		    		var atLeastOneplayerIsND = false;
		    		team.players.forEach((player, playerIdx, players) => {

		    			var ratingNum = 0;

		    			if (player.ratings.length > 0) {
		    				var ratingStr = player.ratings[0].strValue;
		    				var ratingArr = ratingStr.split(",");
		    				var rating = ratingArr[ratingArr.length-1];

		    				if (this.isNumeric(rating)) {
									ratingNum = parseInt(rating);
		    				}
		    				if (rating === "ND") {
		    					atLeastOneplayerIsND = true;
		    				}
		    				teamRating += ratingNum;
		    			}
		    		});

		    		if ((teamRating !== 0) && atLeastOneplayerIsND) {
		    			teams[teamIdx].teamRating = teamRating + " + ND";
		    		} else {
		    			teams[teamIdx].teamRating = teamRating;
		    		}

		    		// HomeSites
		    		var foundHomeSite = false;
		    		if (team.homeSite === "") {
		    			team.homeSite = "(Domicile indéterminé)";
		    		}
		    		homeSites.forEach(hs => {
		    			foundHomeSite |= (team.homeSite === hs.name);
		    		});
		    		if (!foundHomeSite) {
		    			homeSites.push({name: team.homeSite});	
		    		}
		    	});

		    	homeSites = homeSites.sort((a, b) => (a.name.localeCompare(b.name)));
		    	var genericIdx = 1;
					var prevNbTeams = 0;
		    	homeSites.forEach((homeSite, homeSiteIdx) => {
						homeSites[homeSiteIdx].genericIdx = genericIdx;
						prevNbTeams = teams.filter(t => (t.homeSite === homeSite.name)).length;
						genericIdx += prevNbTeams;
		    	});

					this.setState({
						season: season,
						teams: teams,
						homeSites: homeSites,
						loading: false
					});
				}
			});
		});
	}

 	render() {
		// console.log('TeamRosters: render');
    const { season } = this.state;
    const { connectedUser } = this.context;
		var hiddenRatingsMsgEnabled = connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;

		var text1 = "COMPOSITION DES ÉQUIPES";
		var text2 = "Nombre d'équipes: ";
		if (season.formatTeamIndiv !== "TEAMS") {
			text1 = "LISTE DES INSCRIPTIONS";
			text2 = "Nombre de groupes: ";
		}

		return (
			<div className="animated fadeIn">

				<div className="row">
				<div className="col-md-12">
					<h4>{season.name}</h4>
					<p><strong>{text1}</strong></p>
					<p>{text2}{this.state.teams.length}</p>
				</div>
				</div>

				<div className="row">
				<div className="col-md-6">
				<label className="switch switch-3d switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={this.state.groupByHomeSite || false} onChange={this.groupByHomeSiteSwitchChange}/>
					<span className="switch-label"></span>
					<span className="switch-handle"></span>
				</label>
				&nbsp;&nbsp;Grouper par domicile
				</div>
				</div>

				{hiddenRatingsMsgEnabled ? 
					<p className="noRatingMessages"> Les cotes des joueurs sont masquées pour les utilisateurs non-administrateurs </p> 
				: null}

				<hr className="hrThick"/>

				{this.dispTeams()}
			</div>
		);
	}

	dispTeams() {
		if (this.state.groupByHomeSite) {
			return (
				<div>
					{this.state.homeSites.map(this.dispHomeSiteSection)}
				</div>
			)
		} else {
			return(
				<div className="row">
					{this.state.teams.map(this.dispTeam.bind(this, 0, 1))}
				</div>
			)
		}
	}

	dispHomeSiteSection(homeSite, homeSiteIdx, homeSites) {
		var homeSiteTeams = this.state.teams.filter(t => (t.homeSite === homeSite.name));
		return (
			<div key={"hs." + homeSiteIdx}>
				<div className="row">
				<div className="col-md-12">
					<h5>{homeSite.name}</h5>
					<p>Nombre d'équipes: {homeSiteTeams.length}</p>
				</div>
				</div>
				<div className="row">
					{homeSiteTeams.map(this.dispTeam.bind(this, homeSiteIdx, homeSite.genericIdx))}
				</div>
				<hr className="hrThick"/>
			</div>
		)
	}

	dispTeam(homeSiteIdx, genericIdx, team, teamIdx, teams) {
    // Hide TRS if parameter is set and if we are not in Admin mode
    const { connectedUser } = this.context;
    const { season } = this.state;

		var hideRatings = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;

		return (
			<div key={"team." + homeSiteIdx + "." + teamIdx} className="col-md-4">
	      <Card>
	       	<CardHeader>
          	<strong> {team.name} </strong><br/>
          	<span className="smallcaps">{team.homeSite}</span><br/>

          	{((season.formatTeamIndiv === "TEAMS") && !hideRatings && (team.teamRating !== 0)) ?
          		<span className="smallcaps">TRS: {team.teamRating}</span>
          	: null}
	        </CardHeader>
	        <CardBody>
						<div className="row">
						<div className="col-md-12 table-responsive">

							<table className="table table-hover table-sm noBorderTop">
							<thead>
								<tr>
									<th>Joueur</th>
									{!hideRatings ?	<th>TRS</th> : null}
								</tr>
							</thead>
							<tbody>
							{/* map hre */}
							{team.players.map(this.dispPlayers.bind(this, teamIdx))}
							</tbody>
							</table>
							</div>
						</div>

		      </CardBody>
{/*
		    	<CardFooter>
	          <p className="small">TRS</p>
		    	</CardFooter>
*/}
				</Card>
			</div>
		)
	}

	dispPlayers(teamIdx, player, playerIdx, players) {
    const { connectedUser } = this.context;
    const { season } = this.state;

    // Hide TRS if parameter is set and if we are not in Admin mode
		var hideRatings = !connectedUser?.isSeasonAdmin && season.hideRatingsInStandings;
		return (
			<tr key={"player." + teamIdx + "." + playerIdx}> 
				<td> {player.name} </td>
				{!hideRatings ? <td> {player.ratings[0].strValueWithTemp} </td> : null}
			</tr>
		)
	}

  groupByHomeSiteSwitchChange(e) {
		var groupByHomeSite = e.target.checked;
		this.setState({
			groupByHomeSite: groupByHomeSite
		});
  }

	// isNumeric function in javascript
	isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default withRouter(TeamRosters);

